export default "__VITE_ASSET__b1d5310f__"